import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/Button';
export function BookingCTA() {
  const navigate = useNavigate();
  return <section className="py-24 bg-jet relative border-y border-golden/20" data-id="element-57">
      <div className="absolute inset-0 pattern-dots opacity-20" data-id="element-58"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="border border-golden/30 p-8 md:p-16 rounded-sm bg-jet/80 backdrop-blur-md relative overflow-hidden" data-id="element-60">
          {/* Corner ornaments */}
          <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-golden m-4" data-id="element-61"></div>
          <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-golden m-4" data-id="element-62"></div>
          <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-golden m-4" data-id="element-63"></div>
          <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-golden m-4" data-id="element-64"></div>

          <h2 className="text-4xl md:text-6xl font-heading font-bold text-golden mb-6 text-glow" data-id="element-65">
            Ready to Transform Your Look?
          </h2>

          <p className="text-cream/80 text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-66">
            Secure your spot today. Our calendar fills up quickly, and we'd love
            to craft your next protective style.
          </p>

          <Button variant="primary" size="lg" className="w-full sm:w-auto text-lg px-12" onClick={() => navigate('/booking')} data-id="element-67">
            Book Appointment Now
          </Button>

          <p className="mt-6 text-sm text-brown/80" data-id="element-68">
            A non-refundable deposit is required to secure all bookings.
          </p>
        </motion.div>
      </div>
    </section>;
}